var __default__ = {container:'m_8478a6da',root:'m_410352e9',inner:'m_dee7bd2f',col:'m_96bdd299'};
export default __default__;